//
export default [
    {
        name: 'rut',
        props: {
            label: 'RUT',
        },
        type: 'rut-field',
        value: '',
    },
    {
        name: 'business_name',
        props: {
            label: 'Razón social',
        },
        type: 'text-field',
        value: '',
    },
    /*{
        name: 'alias_name',
        props: {
            label: 'Alias',
        },
        type: 'text-field',
        value: '',
    },*/
    {
        name: 'core_business',
        props: {
            label: 'Nombre de negocio',
        },
        type: 'text-field',
        value: '',
    },
    {
        name: 'blocked_sales',
        props: {
            clearable: true,
            items: [
                {
                    text: 'Si',
                    value: 'true',
                },
                {
                    text: 'No',
                    value: 'false',
                },
            ],
            label: 'Tiendas bloqueadas',
            singleLine: false,
        },
        noPrepend: true,
        type: 'select',
        value: '',
    },
    {
        name: 'is_available_ground_seller',
        props: {
            clearable: true,
            items: [
                {
                    text: 'Si',
                    value: 'true',
                },
                {
                    text: 'No',
                    value: 'false',
                },
            ],
            label: 'Tiendas habilitado un vendedor en terreno',
            singleLine: false,
        },
        noPrepend: true,
        type: 'select',
        value: '',
    },
]
